// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"54899abc","879":"54899abc","886":"74520175"}[chunkId] + ".chunk.css";
};